import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEpgVersion } from 'action-creators/epgVersion';
import { fetchEpgLineUp } from 'action-creators/epgLineUp';
import { fetchEpgChannel } from 'containers/Player/actions/epgChannels';
import { GetEpgVersion, tvEverywhereEnable } from 'utils/getEpgParams';
import { fetchPaywayLinealChannels } from 'action-creators/infinite';
import { PlayerContext } from 'containers/Player/context/PlayerContext';
import CombinedContext from 'context/CombinedContext';

const EpgProvider = ({ children }) => {
  const dispatch = useDispatch();
  const epgVersion = useSelector(state => state.epgVersion);
  const epgMenu = useSelector(state => state.epgMenu);
  const user = useSelector(state => state.user);
  const quantity = useSelector(state => state?.EpgLineUp?.quantity);
  const [readyVersionAndMenu, setReadyVersionAndMenu] = useState(false);
  const { setHasFetchedEpgs } = useContext(PlayerContext);
  const { setIsLinealChannelReady } = useContext(CombinedContext);
  const { modalVisibility } = useSelector(state => state.resetPassword);
  const isForgettenPassword = window.location.pathname?.includes('forgottenPassword');

  useEffect(() => {
    if(isForgettenPassword || modalVisibility) return;
    setReadyVersionAndMenu(false);
    let params = {};
    const data = JSON.parse(localStorage.getItem('loginInfo.logged_user_data'));
    if (data && data.subregion) {
      params = { subregion: data?.subregion };
    }
    dispatch(
      fetchEpgVersion(params, () => {
        setReadyVersionAndMenu(true);
      }),
    );
  }, []);

  useEffect(
    () => {
      if(isForgettenPassword || modalVisibility) return;
      if (readyVersionAndMenu) {
        const { epg_version } = epgVersion;
        const node_id = epgMenu?.epgMenu?.nodes?.[0]?.id;
        const params = {
          node_id,
        };
        if (GetEpgVersion() && tvEverywhereEnable()) {
          params.epg_version = epg_version;
        }
        dispatch(fetchEpgLineUp(params));
      }
    },
    [readyVersionAndMenu],
  );

  useEffect(
    () => {
      if(isForgettenPassword || modalVisibility) return;
      if (readyVersionAndMenu && quantity > 0) {
        const { epg_version } = epgVersion;
        const node_id = epgMenu?.epgMenu?.nodes?.[0]?.id;
        const params = {
          node_id,
          quantity: quantity,
        };
        if (GetEpgVersion() && tvEverywhereEnable()) {
          params.epg_version = epg_version;
        }
        dispatch(fetchEpgChannel(params, () => setHasFetchedEpgs(true)));
      }
    },
    [readyVersionAndMenu, quantity],
  );
  useEffect(() => {
    if(isForgettenPassword || modalVisibility) return;
    dispatch(
      fetchPaywayLinealChannels(
        window.getConfig,
        {
          user_id: user?.user_id,
        },
        () => setIsLinealChannelReady(true),
      ),
    );
  }, []);
  return <>{children}</>;
};

export default EpgProvider;
